<script lang="ts">
	// The shop's address on a restaurant's page (UC-31), in its block: cut to
	// one line, and a tap opens it whole on a line of its own across the
	// block; a second tap folds it. It opens like the till's order Details,
	// and follows the read-back rule of the Patterns board: what is cut to fit
	// is shown whole once asked for. Drawn by the worker with the page, then
	// mounted over that markup; before then the address shows cut.

	import Button from '../components/Button.svelte';

	interface Props {
		address: string;
	}

	let { address }: Props = $props();

	let open = $state(false);
</script>

<span class="short">
	<Button
		testId="catalogue-address"
		tone="text-quiet"
		size="sm"
		label={address}
		trailingIcon={open ? 'up' : 'expand'}
		expanded={open}
		onPress={() => (open = !open)}
	/>
</span>
{#if open}
	<p class="full" data-testid="catalogue-address-full">{address}</p>
{/if}

<style>
	.short {
		flex: 1 1 0;
		min-inline-size: 0;
		display: flex;
	}

	/* Button keeps its label on one line and never cuts it, so the cut is
	   made here: the words end in an ellipsis, and the trailing glyph keeps
	   its place at the inline end. */
	.short :global(.btn) {
		position: relative;
		display: block;
		max-inline-size: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: start;
		padding-inline-end: calc(18px + var(--space-3));
	}

	.short :global(.btn > svg:last-child) {
		position: absolute;
		inset-inline-end: 0;
		inset-block-start: 50%;
		translate: 0 -50%;
	}

	/* The block's address row wraps, so this line takes the whole width
	   under the address and the map's link. */
	.full {
		order: 1;
		flex-basis: 100%;
		margin: 0;
		font-size: var(--text-sm);
		line-height: var(--leading-snug);
		color: var(--text-body);
		text-wrap: pretty;
	}
</style>
